import { Route } from '@angular/router';

import { AuthContainerComponent } from './components/auth-container/auth-container.component';
import { BusinessLoginComponent } from './components/business-selection/business-selection.component';
import { ForgetPasswordComponent } from './components/forget-password/forget-password.component';
import { MfaSetupComponent } from './components/mfa-setup/mfa-setup.component';
import { MfaVerifyComponent } from './components/mfa-verify/mfa-verify.component';
import { RedirectFromOldUiComponent } from './components/redirect-from-old-ui/redirect-from-old-ui.component';
import { SignInComponent } from './components/sign-in/sign-in.component';
import { SupportLoginComponent } from './components/support-login/support-login.component';

export const coreLibRoutes: Route[] = [
  {
    path: '',
    component: AuthContainerComponent,
    children: [
      { path: 'sign-in', component: SignInComponent },
      { path: 'business-selection', component: BusinessLoginComponent },
      { path: 'mfa-verify', component: MfaVerifyComponent },
      { path: '', component: SignInComponent, pathMatch: 'full' },
    ],
  },
  { path: 'redirectFromOldUI', component: RedirectFromOldUiComponent },
  { path: 'mfa-setup', component: MfaSetupComponent },
  { path: 'support/:token', component: SupportLoginComponent },
  { path: 'forgot-password/:email', component: ForgetPasswordComponent },
  { path: 'forgot-password', component: ForgetPasswordComponent },
];
